import { render, staticRenderFns } from "./Untie.vue?vue&type=template&id=13ce22a7&scoped=true"
import script from "./Untie.vue?vue&type=script&lang=js"
export * from "./Untie.vue?vue&type=script&lang=js"
import style0 from "./Untie.vue?vue&type=style&index=0&id=13ce22a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ce22a7",
  null
  
)

export default component.exports